//登录模块
import { makeAutoObservable, runInAction, toJS } from "mobx";
import { makePersistable } from 'mobx-persist-store';
import { http, setToken, getToken, removeToken } from '@/utils';
import { message } from 'antd';

//菜单数据
// import menuData from '@/mock/menu'

class LoginStore {
    // 1.定义数据
    token = getToken() || ''
    //用户名
    userName = ''
    //验证码
    captcha = ''
    //验证码表单
    inputCode = ''
    //左侧菜单栏
    menuList = []

    // 2.把数据变成响应式
    constructor() {
        makeAutoObservable(this)
        //持久化存储
        makePersistable(this,
            {
                name: 'mobxMeniuLst',
                properties: ['menuList'],
                storage: window.localStorage,
            }
        )
        makePersistable(this,
            {
                name: 'mobxUserName',
                properties: ['userName'],
                storage: window.localStorage,
            }
        )
    }
    //登录接口
    getToken = async ({ username, password }) => {
        if (this.captcha.toLowerCase() === this.inputCode.toLowerCase()) {
            const relult = await http.post('/adminapi/login/login', {
                username,
                password
            })
            if (relult.data.code === 200) {
                runInAction(() => {
                    this.token = relult.data.data.apitoken
                    this.menuList = JSON.parse(JSON.stringify(relult.data.data.menu))
                    this.userName = relult.data.data.nickname
                    this.jrxtid = relult.data.data.jrxtid
                    localStorage.setItem("jrxtid", relult.data.data.jrxtid)
                    localStorage.setItem("uid", relult.data.data.uid)
                    console.log(toJS(this.menuList), " this.menuList", relult.data)
                })
                window.location.href = '/'
                setToken(this.token)

            } else {
                message.error(relult.data.msg)
            }
        } else {
            message.error('验证码错误');
        }
    }
    //退出登录 删除token
    loginOut = () => {
        this.token = ''
        this.nickname = ''
        this.menuList = []
        removeToken()
        localStorage.removeItem("jrxtid");
    }
}

// 实例化，导出给react 使用
export { LoginStore }